module.exports = __webpack_public_path__ + "img/Icon-Color.7727d4e7.png";